import LockIcon from '@mui/icons-material/Lock'
import { Avatar, Box, Card } from '@mui/material'
import PropTypes from 'prop-types'
import * as React from 'react'
import { Notification } from 'react-admin'

const formCardStyles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    height: '1px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: 'background.default',
  },
  card: {
    minWidth: 300,
    marginTop: '6em',
  },
  avatar: {
    margin: '1em',
    display: 'flex',
    justifyContent: 'center',
  },
  icon: {
    backgroundColor: 'palette.secondary'[500],
  },
}

const FormCard = (props) => {
  const { title, children, shouldCheckAuth, ...rest } = props

  return (
    <Box sx={formCardStyles.main} {...rest}>
      <Card sx={formCardStyles.card}>
        <Box sx={formCardStyles.avatar}>
          <Avatar sx={formCardStyles.icon}>
            <LockIcon />
          </Avatar>
        </Box>
        {children}
      </Card>
      <Notification />
    </Box>
  )
}

FormCard.propTypes = {
  children: PropTypes.node.isRequired,
}

export default FormCard
